import React from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledFileInput from "../../components/Backoffice/ControlledFileInput";
import FormSection from "../../components/Backoffice/FormSection";
import ControlledSelect from "../../components/Backoffice/ControlledSelectV1";

const LabReportUploadForm = ({
  // keyParameters,
  control,
  watch,
  errors,
  options,
  edit = false,
  setValue,
}) => {
  const labReportFile = watch("labReport");
  const labReportMetadataFile = watch("labReportMetadata");
  const disableFields = options.disableFields;

  return (
    <>
      <Form colon={false} layout="vertical">
        <FormSection heading="Upload Lab Report" />
        <Row gutter={24}>
          <Col span={24}>
            <ControlledFileInput
              control={control}
              name="labReport"
              label="Upload Lab Report"
              additionalText="Note: Upload Digital Signed PDF only"
              nameOfFile={labReportFile}
              acceptedFileType={[
                "application/pdf"
              ]}
              valueForInputField={
                control._defaultValues.labReport
                  ? control._defaultValues.labReport
                  : ""
              }
              errors={errors}
              required={true}
            />
          </Col>
        </Row>
        <FormSection heading="Provide Metadata" />
        <Row gutter={24}>
          <Col span={24}>
            <ControlledFileInput
              control={control}
              name="labReportMetadata"
              label="Upload Lab Report Metadata"
              additionalText="Note: Upload separate files for each instrument"
              nameOfFile={labReportMetadataFile}
              acceptedFileType={[
                "zip",
                "application/pdf",
                "application/zip",
                "application/x-zip",
                "application/x-zip-compressed",
                "jpeg",
                "jpg",
                "image/jpeg",
                "image/jpg",
                "csv",
                "text/csv",
                "application/csv",
              ]}
              valueForInputField={
                control._defaultValues.labReportMetadata
                  ? control._defaultValues.labReportMetadata
                  : ""
              }
              errors={errors}
              required={true}
            />
          </Col>
        </Row>
        <FormSection heading="Provide Compliant Information" />
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="overallSafetyCompliant"
              label="Sample Overall Safety Compliant"
              options={[
                { label: "Safe", value: "Safe" },
                { label: "Unsafe", value: "Unsafe" },
                { label: "Not Applicable", value: "Not Applicable" },
              ]}
              errors={errors}
              fullLabelWidth={true}
            />
          </Col>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="overallQualityCompliant"
              label="Sample Overall Quality Compliant"
              options={[
                { label: "Standard", value: "Standard" },
                { label: "Sub-standard", value: "Sub-standard" },
                { label: "Not Applicable", value: "Not Applicable" },
              ]}
              errors={errors}
              fullLabelWidth={true}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          {!disableFields.overallLabellingCompliant && (
            <Col span={12}>
              <ControlledSelect
                required
                control={control}
                name="overallLabellingCompliant"
                label="Sample Overall Labelling Compliant"
                options={[
                  { label: "Branded", value: "Branded" },
                  { label: "Mis-Labelled", value: "Mis-Labelled" },
                ]}
                errors={errors}
                fullLabelWidth={true}
              />
            </Col>
          )}

          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="overallSampleClassification"
              label="Overall Classification of Sample"
              options={[
                { label: "Compliant", value: "Compliant" },
                { label: "Unsafe", value: "Unsafe" },
                { label: "Sub-standard", value: "Sub-standard" },
                { label: "Mis-Labelled", value: "Mis-Labelled" },
              ]}
              errors={errors}
              fullLabelWidth={true}
            />
          </Col>
        </Row>

        {/* <FormSection heading="Provide Key Parameters Values" /> */}
        {/* {keyParameters.map((row, rowIndex) => (
          <Row gutter={24} key={`row-${rowIndex}`}>
            {row.map((col, colIndex) => (
              <Col span={12} key={`col-${colIndex}`}>
                <ControlledInput
                  required
                  fullLabelWidth={true}
                  control={control}
                  name={col.key}
                  label={col.parameter}
                  errors={errors}
                />
              </Col>
            ))}
          </Row>
        ))} */}
      </Form>
    </>
  );
};

export default LabReportUploadForm;
